import React from 'react';
import { BaSeTheme } from '../../theme';
import { BaSeSmall1 } from '../typography/small/small1';
import { DroppableProvided } from 'react-beautiful-dnd';
import { BaSeI18nConsumer } from '../../contexts/i18n';

import * as Styled from './board-styled';
import { BoardColumn } from './board';

export const ListWithoutItems: React.FC<{
  column: BoardColumn;
  provided: DroppableProvided;
}> = ({ column, provided }) => (
  <Styled.BoardWithoutItems
    bgColor={column.backgroundColor}
    {...provided.droppableProps}
    ref={provided.innerRef}
  >
    <BaSeSmall1 color={BaSeTheme.colors.institucionais.azulSebrae36}>
      <BaSeI18nConsumer>
        {({ getMessage }) =>
          column.textWithoutItems ?? getMessage('board.columnPlaceholder')
        }
      </BaSeI18nConsumer>
      {provided.placeholder}
    </BaSeSmall1>
  </Styled.BoardWithoutItems>
);
